import React, { useEffect, useState, useRef, useMemo } from "react";
import md1 from "../../assets/md1.webp";
import md2 from "../../assets/md2.webp";
import DirectorCard from "./DirectorCard";

// Move directors array outside the component or memoize it
const directorsData = [
  {
    image: md1,
    name: "Mr. Gaurav Bhattar ",
    title: "Director, Multify Solutions Private Limited",
    description: `Gaurav Bhattar brings a wealth of experience and visionary leadership to Multify Solutions Private Limited. As the Managing Director of Shri Ram Finance Corporation Private Limited and Non-Executive Director at Shri Ram Insurance Brokers Private Limited, he has been pivotal in scaling businesses to new heights. His strategic acumen and deep understanding of the financial and IT sectors have established Multify as a trusted industry leader. Gaurav's commitment to innovation, regional development, and data sovereignty drives Multify's mission to bridge technology gaps and foster growth in underserved markets. Under his guidance, Multify is transforming Chhattisgarh into a digital hub with its AI-powered community data center, pioneering in public, private, and hybrid cloud hosting.`,
  },
  {
    image: md2,
    name: "Mrs. Swati Bhattar ",
    title: "Director, Multify Solutions Private Limited",
    description: `Swati Bhattar's extensive expertise and dedication are integral to the success of Multify Solutions Private Limited. As a Non-Executive Director at Shri Ram Finance Corporation and Shri Ram Insurance Brokers Private Limited, she plays a key role at Multify in advancing the company's mission of delivering cutting-edge IT solutions. Swati's focus on innovation, customer satisfaction, and socio-economic impact ensures that Multify consistently exceeds client expectations. She is committed to establishing Chhattisgarh as a central IT hub, fostering digital transformation through innovative, sustainable, and cost-effective solutions, and addressing regional challenges such as cybersecurity risks and employment gaps. Swati's leadership in promoting local talent development and advancing data sovereignty is pivotal to Multify's growth and success.`,
  },
];

const DirectorsSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const imageRefs = useRef([]);
  const [tooltipPositions, setTooltipPositions] = useState([]);

  // Memoize directors array to prevent re-creation on every render
  const directors = useMemo(() => directorsData, []);

  useEffect(() => {
    const positions = directors.map((_, index) => {
      if (imageRefs.current[index]) {
        const rect = imageRefs.current[index].getBoundingClientRect();
        return { height: rect.height };
      }
      return { height: 0 };
    });
    setTooltipPositions(positions);
  }, [directors]); // Now directors is stable and won't cause infinite loops

  return (
    <div className="pt-10 md:pt-20">
      <h2 className="text-4xl md:text-5xl lg:text-6xl text-white text-center py-6 md:py-10">
        Board of Directors
      </h2>
      <div className="flex flex-col md:flex-row justify-center md:justify-between flex-wrap">
        {directors.map((director, index) => (
          <DirectorCard
            key={index}
            director={director}
            index={index}
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
            imageRef={(el) => (imageRefs.current[index] = el)}
            tooltipPosition={tooltipPositions[index]}
          />
        ))}
      </div>
    </div>
  );
};

export default DirectorsSection;
